window.addEventListener('klaviyoForms', async function (event) {
	const triggerCampaignData = window.theme.triggerCampaign;
	if (!triggerCampaignData) return;

	const { id: campaignId, trigger: triggerCampaign, klaviyoFormId: formId } = triggerCampaignData;
	if (!campaignId || !triggerCampaign || !formId || triggerCampaign === "false") return;
	if (event.detail.type === 'submit' && event.detail.formId === formId) {
		const klaviyoFormId = event.detail.formId;
		if (klaviyoFormId !== formId) return;
		const email = event.detail.metaData.$email;
		const BASE_URL = 'https://bloyal-app-production-4451.up.railway.app';

		ensureStatusModal();
		openStatusModal(
			triggerCampaignData?.translations?.processing_title,
			triggerCampaignData?.translations?.processing_message,
			'loading'
		);

		const requestUrl = `${BASE_URL}/customers/add-to-store-credit-from-link?email=${encodeURIComponent(email)}&campaign=${campaignId}&store=${window.theme.settings.store_name}`;
		for (let i = 0; i < 10; i++) {
			const responseStatus = await addStoreCredit(requestUrl);

			if (responseStatus) {
				wasStoreCreditAdded = true;
				break;
			} else {
				await new Promise(resolve => setTimeout(resolve, 4000));
			}
		}

		if (wasStoreCreditAdded) {
			updateStatusModal(
				triggerCampaignData?.translations?.success_title,
				triggerCampaignData?.translations?.success_message,
				'success'
			);
		} else {
			updateStatusModal(
				triggerCampaignData?.translations?.error_title,
				triggerCampaignData?.translations?.error_message,
				'error'
			);
		}
	}
});

async function addStoreCredit(requestUrl) {
	try {
		const response = await fetch(requestUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});
		if (response.ok) {
			const data = await response.json();
			const urlRedirection = data.redirectURL;
			if (!urlRedirection || urlRedirection === null) return false;
			console.log('API call successful', data);
			return true;
		} else {
			console.warn(`HTTP error! Status: ${response.status}`);
			return false;
		}
	} catch (error) {
		console.error('API call failed:', error);
		return false;
	}
}

function ensureStatusModal() {
	const overlayModal = document.getElementById('klaviyo-status-modal');
	if (overlayModal) return;
	const ksmModal = document.querySelector('.ksm-modal');
	if (!ksmModal) return;
	const overlay = document.createElement('div');
	overlay.className = 'ksm-overlay';
	overlay.id = 'klaviyo-status-modal';
	overlay.setAttribute('role', 'dialog');
	overlay.setAttribute('aria-modal', 'true');
	const ksmModalClone = ksmModal.cloneNode(true);
	ksmModalClone.removeAttribute('hidden');
	overlay.appendChild(ksmModalClone);

	overlay.addEventListener('click', (e) => {
		if (e.target === overlay) closeStatusModal();
	});
	const closeBtn = overlay.querySelector('[data-action="close"]');
	if (closeBtn) closeBtn.addEventListener('click', closeStatusModal);
	document.body.appendChild(overlay);
}

function openStatusModal(title, message, state = 'loading') {
	const overlay = document.getElementById('klaviyo-status-modal');
	if (!overlay) return;
	updateStatusModal(title, message, state);
	overlay.style.display = 'flex';
}

function updateStatusModal(title = '', message = '', state = 'loading') {
	const overlay = document.getElementById('klaviyo-status-modal');
	if (!overlay) return;
	const titleEl = overlay.querySelector('.ksm-title');
	const msgEl = overlay.querySelector('.ksm-message');
	const statusEl = overlay.querySelector('.ksm-status-indicator');
	if (titleEl) titleEl.textContent = title || '';
	if (msgEl) msgEl.textContent = message || '';
	if (statusEl) {
		statusEl.classList.remove('success', 'error', 'loading', 'ksm-status-success', 'ksm-status-error', 'ksm-status-loading');
		statusEl.classList.add(state);
	}
}

function closeStatusModal() {
	const overlay = document.getElementById('klaviyo-status-modal');
	if (!overlay) return;
	overlay.style.display = 'none';
}